import Head from "next/head";

import PartnerDetails from "@/components/partners/partner-details";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function Partner() {
  return (
    <>
      <Head>
        <title>{seoData.PARTNER.title}</title>
        <SeoMetaData data={seoData.PARTNER} />
      </Head>

      <PartnerDetails />
    </>
  );
}
